(() => {
  const main = document.querySelector('main[data-template]');
  if (!main || document.documentElement.classList.contains('shopify-design-mode')) return;
  const template = String(main.dataset.template || '').toLowerCase();
  if (!/^(index|page|collection)(\.|$)/.test(template)) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches || !('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const selector = [
    'article', '.collection-card', '.resource-card', '.blog-post-card',
    '.p4-home-v2__intro-heading', '.p4-home-v2__method-heading',
    '.p4-home-v2__team-heading', '.p4-home-v2__challenges-content',
    '.p4-home-v2__final-content', '.p4-home-v2__challenges-media',
    '.p4-about__mission', '.p4-about__identity > div',
    '.p4-about__approach-heading', '.p4-about__challenges-heading',
    '.p4-experts__heading', '.p4-shop__collection-heading',
    '.p4-shop__product-grid > *', '.p4-services-v2__card',
    '.p4-consult-card', '.p4-consult-step', '.p4-aesthetics__booking > div',
    '.text-block', '.image-block', 'h2', 'h3'
  ].join(',');
  const reveal = (node) => {
    node.classList.add('is-revealed');
    observer.unobserve(node);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
  const collect = (scope) => {
    if (preference.matches) return;
    const candidates = [...scope.querySelectorAll(selector)];
    if (scope !== main && scope.matches?.(selector)) candidates.unshift(scope);
    candidates.forEach((node) => {
      if (seen.has(node)) return;
      if (node.closest('p4-team-carousel, form, dialog, [role="dialog"], [hidden], [aria-hidden="true"], .p4-skin-offer')) return;
      if (node.parentElement?.closest('[data-v1-reveal]')) return;
      if (node.querySelector('form, iframe, dialog, [role="dialog"]')) return;
      const rect = node.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      seen.add(node);
      if (rect.top < window.innerHeight * .95) return;
      const index = [...node.parentElement.children].indexOf(node);
      node.style.setProperty('--v1-reveal-delay', `${Math.min(index % 4 * 70, 210)}ms`);
      node.setAttribute('data-v1-reveal', '');
      observer.observe(node);
    });
  };
  collect(main);
  let queued = false;
  const mutations = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; collect(main); });
  });
  mutations.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
  document.addEventListener('shopify:section:load', (event) => {
    if (main.contains(event.target)) collect(event.target);
  });
  main.addEventListener('focusin', (event) => {
    const target = event.target.closest('[data-v1-reveal]');
    if (target) reveal(target);
  });
  preference.addEventListener('change', () => {
    if (preference.matches) {
      main.querySelectorAll('[data-v1-reveal]').forEach(reveal);
      mutations.disconnect();
    }
  });
})();
